import { PageType } from '../enums/pageTypes';
import { APP_PAGES } from '../routes/constants';

export { PageType };

export const getCurrentPageType = (): PageType => {
  const pathname = window.location.pathname;

  if (pathname.includes(APP_PAGES.INBOX_TRASH)) {
    return PageType.TRASH;
  }

  if (pathname.includes(APP_PAGES.INBOX_SPAM)) {
    return PageType.SPAM;
  }

  if (pathname.includes(APP_PAGES.INBOX_SENT)) {
    return PageType.SENT;
  }

  if (pathname.includes(APP_PAGES.INBOX_DRAFT)) {
    return PageType.DRAFT;
  }

  if (pathname.includes(APP_PAGES.INBOX_ALL)) {
    return PageType.ALL;
  }

  if (pathname.includes(APP_PAGES.INBOX_LABELS)) {
    return PageType.LABELS;
  }

  if (pathname.includes(APP_PAGES.DOBOX)) {
    return PageType.DOBOX;
  }

  if (pathname.includes(APP_PAGES.INBOX_SNOOZED)) {
    return PageType.SNOOZED;
  }

  if (pathname.includes(APP_PAGES.INBOX_SCHEDULED)) {
    return PageType.SCHEDULED;
  }

  if (pathname.includes(APP_PAGES.INBOX)) {
    return PageType.INBOX;
  }

  return PageType.UNKNOWN;
};
